// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_IUQ","cls2":"AppsMegaMenu-cls2_GGK AppsMegaMenu-cls1_IUQ"};